import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Table,
  Modal,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Select from "react-select";
import {
  gatAllOackage,
  deletePackage,
  getb2b,
  assignPackage,
  getassignedPackage,
  removeassigedorg,
  getFilteredPackages,
  getCountry,
  getOrganizationDataWithoutPagination,
  resetPackageBalance,
} from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import { withRouter } from "react-router";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class viewProductCatalogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package_detail: [],
      package_name: "",
      package_nameError: null,
      package_duration: "",
      package_durationError: null,
      package_price: "",
      package_priceError: null,
      package_organization: "",
      package_organizationError: null,
      feature_chkError: null,
      n_o_calls: "",
      n_o_callsError: null,
      raya_discount: "",
      raya_discountError: null,
      lab_discount: "",
      lab_discountError: null,
      express_order: "",
      selectedOption: "",
      express_orderError: null,
      medicin_discount: "",
      medicin_discountError: null,
      organizationdetail: [],
      cardHidden: true,
      processing: true,
      feature_chk: [],
      showCouponModal: false,
      subscriber: [],
      organization: "",
      send_to_all: 0,
      subscriberItems: [],
      p_couponid: null,
      organization_id: "0",
      assignPackageError: "",
      showAssignedModal: false,
      packageAssigned: [],
      _notificationSystem: null,
      selectedpackage: "",
      feature_chk_data: [
        {
          id: 1,
          chk_value: 1,
          label: "1st Advice",
          checked: false,
          placeholder: "N.O Calls",
          name: "no_of_calls",
          input_value: "",
          errorMessage: "N.O Calls is required.",
        },
        {
          id: 2,
          chk_value: 2,
          label: "Raya",
          checked: false,
          placeholder: "Enter Discount",
          name: "raya_flat_discount",
          input_value: "",
          errorMessage: "Raya Discount is required.",
        },
        {
          id: 3,
          chk_value: 3,
          label: "Lab",
          checked: false,
          placeholder: "Enter Discount",
          name: "lab_discount",
          input_value: "",
          errorMessage: "Lab Discount is required.",
        },
        {
          id: 4,
          chk_value: 4,
          label: "MBE",
          checked: false,
          placeholder: "MBE Price",
          name: "price",
          input_value: "",
          errorMessage: "MBE Price is required.",
        },
        {
          id: 5,
          chk_value: 5,
          label: "Express",
          checked: false,
          placeholder: "N.O Express order",
          name: "no_of_express_order",
          input_value: "",
          errorMessage: "N.O Express order is required.",
        },
        {
          id: 6,
          chk_value: 6,
          label: "Medicine",
          checked: false,
          placeholder: "Enter Discount",
          name: "medicine_disocunt",
          input_value: "",
          errorMessage: "Medicine discount is required.",
        },
      ],
      loading: false,
      alert: null,
      remove_org_alt: null,
      edit_pkg_alt: null,
      showResetBalanceModal: false,
      reset_balance_id: null,
      reset_start_date: "",
      reset_end_date: "",
      reset_start_date_error: null,
      reset_end_date_error: null,
      paginationData: [],
      noRecordFound: false,
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      userRole: "",
      country_code: "",
      country_detail: [],
      organizationOption: [],
      totalPage: 0,
      packageSearch: "",
      isAssignGroup: false,
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.selectedpackage = this.selectedPackage.bind(this);
    this.ConfirmAndCancelMessage = this.ConfirmAndCancelMessage.bind(this);
    this.removeorg = this.removeorg.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetBalance = this.resetBalance.bind(this);
    this.getFilteredProductCatalouge =
      this.getFilteredProductCatalouge.bind(this);
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    gatAllOackage(obj).then((response) => {
      this.setState({ package_detail: response.data.data.data });
    });
  }

  assignOrganizationModal(id, title) {
    this.setState({
      showCouponModal: true,
      p_couponid: id,
      isAssignGroup: false,
      package_name: title,
    });
  }

  getOrganization(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      showAssignedModal: true,
      selectedpackage: id,
    });

    getassignedPackage(id, obj).then((res) => {
      var organizations = [];
      for (let i = 0; i < res.data.data.length; i++) {
        for (let j = 0; j < this.state.organizationOption.length; j++) {
          if (
            res.data.data[i].organization_id ==
            this.state.organizationOption[j].value
          ) {
            var obj = {
              company_name: this.state.organizationOption[j].label,
              id: this.state.organizationOption[j].value,
            };
            organizations.push(obj);
          }
        }
      }
      this.setState({
        packageAssigned: organizations,
      });
    });
  }

  closeCancelModal() {
    this.setState({
      showCouponModal: false,
      organization: "0",
      isAssignGroup: false,
    });
  }

  closeCancelassignModal() {
    this.setState({ showAssignedModal: false });
  }

  ConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deletePackage(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Package Detail !
          <span className="delete_package_alert_show">
            Users are subscribed to this package, Deleting this will also delete
            their subscription.
          </span>
        </SweetAlert>
      ),
    });
  }

  RemoveOrgMessage(id) {
    this.setState({
      showAssignedModal: false,
      remove_org_alt: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.removeorg(id)}
          onCancel={() => this.remove_org_hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          <span className="delete_package_alert_show">
            Users are subscribed to this package, Removing this will also
            removed their subscription
          </span>
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  remove_org_hideAlert() {
    this.getOrganization(this.state.selectedpackage);
    this.setState({
      remove_org_alt: null,
    });
  }

  EditPackageMessage(id) {
    this.setState({
      showAssignedModal: false,
      edit_pkg_alt: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.selectedPackage(id)}
          onCancel={() => this.EdithideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
          You want to edit this package ?
        </SweetAlert>
      ),
    });
  }

  EditPackageMessageNew(id) {
    this.setState({
      showAssignedModal: false,
      edit_pkg_alt: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.selectedPackageNew(id)}
          onCancel={() => this.EdithideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
          You want to edit this package ?
        </SweetAlert>
      ),
    });
  }

  EdithideAlert() {
    this.setState({
      edit_pkg_alt: null,
    });
  }

  ReplicatePackageMessage(id) {
    this.setState({
      showAssignedModal: false,
      edit_pkg_alt: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.selectedReplicatePackage(id)}
          onCancel={() => this.EdithideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes"
          cancelBtnText="Cancel"
          showCancel
        >
          You want to replicate this package ?
        </SweetAlert>
      ),
    });
  }

  ResetBalanceMessage(id) {
    this.setState({
      showAssignedModal: false,
      showResetBalanceModal: true,
      reset_balance_id: id,
      reset_start_date_error: null,
      reset_end_date_error: null,
    });
  }

  reset_balance_hideAlert() {
    this.setState({
      showResetBalanceModal: false,
      reset_balance_id: null,
      reset_start_date: "",
      reset_end_date: "",
      reset_start_date_error: null,
      reset_end_date_error: null,
    });
  }

  deletePackage(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    deletePackage(id, obj)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.searchData();
      })
      .catch((error) => {
        console.log(error, "== error");
        // this.handleNetworkError("bl", error);
      });
  }

  resetBalance(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    const { reset_start_date, reset_end_date } = this.state;
    let hasError = false;
    let reset_start_date_error = null;
    let reset_end_date_error = null;

    if (!reset_start_date) {
      hasError = true;
      reset_start_date_error = (
        <small className="text-danger">Please select a start date.</small>
      );
    }

    if (!reset_end_date) {
      hasError = true;
      reset_end_date_error = (
        <small className="text-danger">Please select an end date.</small>
      );
    }

    if (
      reset_start_date &&
      reset_end_date &&
      new Date(reset_end_date) < new Date(reset_start_date)
    ) {
      hasError = true;
      reset_end_date_error = (
        <small className="text-danger">
          End date should be the same as or after the start date.
        </small>
      );
    }

    if (hasError) {
      this.setState({
        reset_start_date_error,
        reset_end_date_error,
      });
      return;
    }

    this.setState({ loading: true });

    resetPackageBalance(id, reset_start_date, reset_end_date, obj)
      .then((response) => {
        this.setState({
          showResetBalanceModal: false,
          reset_balance_id: null,
          reset_start_date: "",
          reset_end_date: "",
          loading: false,
        });

        if (response.data.success == false) {
          this.handleResetBalanceError("bl", response.data.message);
        } else {
          this.handleResetBalanceSuccess("bl", response.data.data);
        }
      })
      .catch((error) => {
        this.setState({
          showResetBalanceModal: false,
          reset_balance_id: null,
          reset_start_date: "",
          reset_end_date: "",
          loading: false,
        });
        this.handleResetBalanceError("bl", getApiErrorMessage(error));
      });
  }

  handleResetStartDateChange = (event) => {
    this.setState({
      reset_start_date: event.target.value,
      reset_start_date_error: null,
    });
  };

  handleResetEndDateChange = (event) => {
    this.setState({
      reset_end_date: event.target.value,
      reset_end_date_error: null,
    });
  };

  removeorg(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    removeassigedorg(id, this.state.selectedpackage, obj)
      .then((res) => {
        this.handleSuccessremove("bl");
        this.getOrganization(this.state.selectedpackage);
        this.setState({
          remove_org_alt: null,
        });
      })
      .catch((err) => console.log(err));
  }

  paginationinfo(url, id) {
    this.setState({
      page: url,
    });
    this.selectstatus(id);
  }

  selectedPackage(cus) {
    localStorage.setItem("packageId", JSON.stringify(cus));
    this.props.history.push("/admin/editProductCatalogue");
  }
  selectedPackageNew(cus) {
    localStorage.setItem("packageId", JSON.stringify(cus));
    this.props.history.push("/admin/editProductCatalogueNew");
  }

  selectedReplicatePackage(cus) {
    localStorage.setItem("packageId", JSON.stringify(cus));
    this.props.history.push("/admin/replicateProductCatalogue");
  }

  inputOnChangeOrganizarion = (event) => {
    const self = this;
    self.setState({
      organization: event,
    });
    /* setTimeout(function () {
           self.sendToParentOrgSubscriber(self.state.organization);
         }, 300);*/
  };

  assignPackage() {
    let error = false;
    if (this.state.organization_id == 0) {
      error = true;
      this.setState({
        assignPackageError: (
          <small className="text-danger">Please select any organization.</small>
        ),
      });
    } else {
      this.setState({ assignPackageError: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      assignPackage(
        this.state.organization_id,
        this.state.p_couponid,
        this.state.isAssignGroup,
        this.state.package_name,
        obj,
      )
        .then((response) => {
          if (response.data.success == false) {
            this.handleClick("bl");
          } else {
            this.setState({
              showCouponModal: false,
              organization: "0",
            });
            this.handleSuccess("bl");
          }
        })
        .catch((err) => console.log(err));
    }
  }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Organization assigned successfully.</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleResetBalanceSuccess(position, data) {
    const resetLeads = data && data.reset_leads ? data.reset_leads : 0;
    const resetAmount = data && data.reset_amount ? data.reset_amount : 0;

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>
            Reset balance completed. Leads: {resetLeads}, Amount: {resetAmount}
          </b>
        </div>
      ),
      level: "success",
      position: position,
      autoDismiss: 15,
    });
  }

  handleResetBalanceError(position, message) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message || "Balance reset failed."}</b>
        </div>
      ),
      level: "error",
      position: position,
      autoDismiss: 15,
    });
  }

  handleSuccessremove(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Organization removed successfully.</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Organization already asigned.</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ userRole: token.role });

    getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    if (!this.state.country_code) {
      await this.getAllPackageDetails(this.state.currentPage);
    }

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    let pg_no = 1;
    let compelte = 1;
    getOrganizationDataWithoutPagination(obj).then((res) => {
      const companyData = res.data;
      const organizationDetail = companyData.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      this.setState({ organizationOption: organizationDetail });
    });
  }

  async getAllPackageDetails(page) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ loading: true });
    await gatAllOackage(obj, page).then((response) => {
      this.setState({
        package_detail: response.data.data.data,
        totalPage: response.data.data.last_page,
        currentPage: page,
      });
    });
    this.setState({ loading: false });
  }

  getFilteredProductCatalouge(country_code) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let package_name = this.state.packageSearch;
    this.setState({ loading: true });
    getFilteredPackages(obj, country_code, package_name).then((response) => {
      this.setState({ package_detail: response.data.data.data });
      this.setState({ loading: false });
    });
  }

  addproductcatalouge() {
    this.props.history.push("addProductCatalogue");
  }
  addproductcatalougeNew() {
    this.props.history.push("addProductCatalogueNew");
  }
  onParentOrganizationChange = (value) => {
    this.setState({
      organization_id: value.value,
    });
  };

  viewPagination() {
    let active = this.state.currentPage;
    let items = [];
    for (let number = 1; number <= this.state.totalPage; number++) {
      items.push(
        <Pagination.Item
          onClick={() => this.getAllPackageDetails(number)}
          active={number === active}
        >
          {number}
        </Pagination.Item>,
      );
    }
    return items;
  }

  onPackageSearchChange = (e) => {
    this.setState({ packageSearch: e.target.value });
    if (e.target.value == "") {
      this.getAllPackageDetails(this.state.currentPage);
    } else {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      this.setState({ loading: true });
      getFilteredPackages(obj, "", e.target.value).then((response) => {
        this.setState({
          package_detail: response.data.data.data,
          totalPage: response.data.data.last_page,
          currentPage: 1,
        });
      });
      this.setState({ loading: false });
    }
  };
  resetFilter() {
    this.setState({ packageSearch: "" });
    this.getAllPackageDetails(this.state.currentPage);
  }
  render() {
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    // const editNew = <Tooltip id="editNew">EditNew</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const assign = <Tooltip id="payment">Assign Organization</Tooltip>;
    const replicate = <Tooltip id="replicate">Replicate</Tooltip>;
    const couponowner = <Tooltip id="couponowner">Assigned to</Tooltip>;
    const resetBalance = <Tooltip id="resetBalance">Reset Balance</Tooltip>;
    const organizationdetail = this.state.organizationdetail;
    const all_package_detail = this.state.package_detail;

    let c = 1;
    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          {this.state.remove_org_alt}
          {this.state.edit_pkg_alt}
          <Modal
            show={this.state.showResetBalanceModal}
            onHide={() => this.reset_balance_hideAlert()}
          >
            <Modal.Header closeButton>
              <Modal.Title>Reset Balance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                <ControlLabel>Start Date</ControlLabel>
                <FormControl
                  type="date"
                  value={this.state.reset_start_date}
                  onChange={this.handleResetStartDateChange}
                />
                {this.state.reset_start_date_error}
              </FormGroup>
              <FormGroup>
                <ControlLabel>End Date</ControlLabel>
                <FormControl
                  type="date"
                  value={this.state.reset_end_date}
                  onChange={this.handleResetEndDateChange}
                />
                {this.state.reset_end_date_error}
              </FormGroup>
              <small className="text-muted">
                Only wallet transactions created within this date range will be
                reset to zero.
              </small>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.reset_balance_hideAlert()}>
                Cancel
              </Button>
              <Button
                bsStyle="warning"
                onClick={() => this.resetBalance(this.state.reset_balance_id)}
              >
                Reset Balance
              </Button>
            </Modal.Footer>
          </Modal>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col xs={3} sm={3} md={3} lg={3}>
              <FormControl
                className="btn-fill btn-size"
                name="packageSearch"
                value={this.state.packageSearch || ""}
                placeholder="Package Search"
                onChange={(e) => this.onPackageSearchChange(e)}
                type="text"
              />
            </Col>
            <Col xs={2} sm={2} md={2} lg={2}>
              <Button
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                onClick={() => this.resetFilter()}
                style={{ marginTop: "5px" }}
              >
                Reset
              </Button>
            </Col>
            <Col
              xs={7}
              sm={7}
              md={7}
              lg={7}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Col
                xs={6}
                sm={6}
                md={6}
                lg={6}
                className="text-right"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: 0,
                  paddingBottom: 10,
                }}
              >
                <Row style={{ display: "flex", gap: 8 }}>
                  <select
                    name="country"
                    onChange={(event) => {
                      this.setState({
                        country_code: event.target.value,
                      });
                      this.getFilteredProductCatalouge(event.target.value);
                    }}
                    className="form-control"
                  >
                    <React.Fragment>
                      <option value="LK">Select Country</option>
                      {this.state.country_detail.map((country_data) => (
                        <option value={country_data.country_code}>
                          {country_data.country_name}
                        </option>
                      ))}
                    </React.Fragment>
                  </select>
                  <Button
                    className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                    onClick={this.addproductcatalouge.bind(this)}
                  >
                    Add Catalogue <i className="fa fa-plus"></i>
                  </Button>
                  <Button
                    className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                    onClick={this.addproductcatalougeNew.bind(this)}
                  >
                    Add Catalogue New <i className="fa fa-plus"></i>
                  </Button>
                </Row>
                <br />
                &nbsp;
              </Col>
            </Col>
            <Col md={12}>
              <Card
                content={
                  <React.Fragment>
                    <Row>
                      <Col md={12}>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>Package Logo</th>
                              <th>Title</th>
                              <th>Duration</th>
                              <th>Description</th>
                              <th>Type</th>
                              <th>Price</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loading ? (
                              <tr>
                                <td colspan="10">
                                  <LoadingSpinner />
                                </td>
                              </tr>
                            ) : this.state.noRecordFound ? (
                              <tr>
                                <td colspan="10">
                                  <center>No record found</center>
                                </td>
                              </tr>
                            ) : (
                              <React.Fragment>
                                {all_package_detail.map((cus, i) => (
                                  <tr key={i}>
                                    <td>
                                      {cus.package_logo ? (
                                        <img
                                          style={{
                                            height: "35px",
                                            width: "35px",
                                            border: "1px solid black",
                                            "border-radius": "50%",
                                          }}
                                          src={cus.package_logo}
                                        ></img>
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      key={cus.id}
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {cus.title}
                                    </td>
                                    <td>{`${cus.duration} ${
                                      cus.duration_type == 1
                                        ? "Day"
                                        : cus.duration_type == 2
                                          ? "Week"
                                          : cus.duration_type == 3
                                            ? "Month"
                                            : cus.duration_type == 4
                                              ? "Year"
                                              : ""
                                    }`}</td>
                                    <td>{cus.description}</td>
                                    <td>{` ${
                                      cus.user_type == 1
                                        ? "B2B"
                                        : cus.user_type == 2
                                          ? "B2C"
                                          : ""
                                    }`}</td>
                                    <td>{cus.price}</td>
                                    <td className="td-actions">
                                      {this.state.userRole == 1 && (
                                        <>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={edit}
                                          >
                                            <Button
                                              simple
                                              bsStyle="success"
                                              onClick={this.EditPackageMessage.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-edit" />
                                            </Button>
                                          </OverlayTrigger>
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={edit}
                                          >
                                            <Button
                                              simple
                                              bsStyle="success"
                                              onClick={this.EditPackageMessageNew.bind(
                                                this,
                                                cus.id,
                                              )}
                                              bsSize="xs"
                                            >
                                              <i className="fa fa-edit" />
                                            </Button>
                                          </OverlayTrigger>
                                        </>
                                      )}

                                      <OverlayTrigger
                                        placement="top"
                                        overlay={couponowner}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.getOrganization.bind(
                                            this,
                                            cus.id,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-id-badge" />
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        placement="top"
                                        overlay={assign}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.assignOrganizationModal.bind(
                                            this,
                                            cus.id,
                                            cus.title,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-share" />
                                        </Button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        placement="top"
                                        overlay={replicate}
                                      >
                                        <Button
                                          simple
                                          bsStyle="success"
                                          onClick={this.ReplicatePackageMessage.bind(
                                            this,
                                            cus.id,
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-copy" />
                                        </Button>
                                      </OverlayTrigger>

                                      {this.state.userRole == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={resetBalance}
                                        >
                                          <Button
                                            simple
                                            bsStyle="warning"
                                            onClick={this.ResetBalanceMessage.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-refresh" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}

                                      {this.state.userRole == 1 && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.ConfirmAndCancelMessage.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </React.Fragment>
                            )}
                          </tbody>
                        </Table>
                        <div style={{ textAlign: "center" }}>
                          <Pagination>{this.viewPagination()}</Pagination>
                        </div>
                      </Col>

                      <Modal
                        show={this.state.showAssignedModal}
                        onHide={() =>
                          this.setState({ showAssignedModal: true })
                        }
                      >
                        <Modal.Header>
                          <Modal.Title>Assigned To ...</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FormGroup>
                            <Table responsive>
                              <thead>
                                <tr>
                                  <th>Organization</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.packageAssigned.length > 0 ? (
                                  this.state.packageAssigned.map((cus, key) => (
                                    <tr key={key}>
                                      <td> {cus.company_name}</td>
                                      <td style={{ textAlign: "end" }}>
                                        {" "}
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={() =>
                                            this.RemoveOrgMessage(cus.id)
                                          }
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td> No organization available</td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            onClick={this.closeCancelassignModal.bind(this)}
                            bsStyle="info"
                            fill
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      <Modal
                        show={this.state.showCouponModal}
                        onHide={() => this.setState({ showCouponModal: true })}
                      >
                        <Modal.Header>
                          <Modal.Title>Assign Package</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <FormGroup>
                            <FormGroup
                              style={{
                                display:
                                  this.state.send_to_all == 1
                                    ? "none"
                                    : "block",
                              }}
                            >
                              <ControlLabel>Select Organization: </ControlLabel>
                              <Select
                                name="source"
                                onChange={(value) =>
                                  this.onParentOrganizationChange(value)
                                }
                                options={this.state.organizationOption}
                              />
                              {this.state.organization_id !== "0" && (
                                <Checkbox
                                  number="checkbox1"
                                  label="Assign to Group"
                                  isChecked={this.state.isAssignGroup}
                                  inline={false}
                                  onChange={(e) =>
                                    this.setState({
                                      isAssignGroup: e.target.checked,
                                    })
                                  }
                                />
                              )}
                            </FormGroup>
                          </FormGroup>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            onClick={this.assignPackage.bind(this)}
                            bsStyle="success"
                            fill
                          >
                            Submit
                          </Button>
                          &nbsp;
                          <Button
                            onClick={this.closeCancelModal.bind(this)}
                            bsStyle="info"
                            fill
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default withRouter(viewProductCatalogue);
